import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgIkonRedigeroplysninger({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 40"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M24.61 11 26 12.44 10.11 28.35a3 3 0 0 1-1.62.84l-4.07.72a2 2 0 0 1-.35 0 2 2 0 0 1-1.42-.59 2 2 0 0 1-.56-1.77l.72-4.08a3 3 0 0 1 .84-1.61L19.56 6 21 7.38ZM30 7.1a3.24 3.24 0 0 0-.91-1.7L26.6 2.89a2.55 2.55 0 0 0-3.6-.37l-2 2L22.38 6 26 9.61 27.43 11l2.05-2A2.07 2.07 0 0 0 30 7.1Z"
                data-name="Layer 2"
            />
            <text
                y={47}
                fontSize={5}
                fontWeight="bold"
                fontFamily="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
            >
                {'Created by scorpicon'}
            </text>
            <text
                y={52}
                fontSize={5}
                fontWeight="bold"
                fontFamily="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
            >
                {'from the Noun Project'}
            </text>
        </svg>
    )
}
SvgIkonRedigeroplysninger.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgIkonRedigeroplysninger
